/**
 * Temps — epoch ms UTC partout, helpers Benin (UTC+1).
 *
 * Convention : on stocke TOUT en epoch ms UTC en DB.
 * On convertit à l'affichage (jamais l'inverse).
 *
 * Pour les tests, on injecte un `Clock` (interface) → jamais de Date.now() direct.
 */

export const BENIN_TZ = 'Africa/Porto-Novo';

export interface Clock {
  now(): number; // epoch ms UTC
}

export const systemClock: Clock = {
  now: () => Date.now(),
};

export const fixedClock = (epochMs: number): Clock => ({
  now: () => epochMs,
});

/** Ajoute N jours à un epoch ms. */
export const addDays = (epochMs: number, days: number): number =>
  epochMs + days * 86_400_000;

/** Ajoute N heures. */
export const addHours = (epochMs: number, hours: number): number =>
  epochMs + hours * 3_600_000;

/** Début du jour en heure locale Bénin (00:00:00 UTC+1). Retourne epoch ms. */
export const startOfDayBenin = (epochMs: number): number => {
  const d = new Date(epochMs);
  // On formate en heure Bénin, on prend l'année-mois-jour, on rebuild en UTC.
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: BENIN_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
  const parts = formatter.formatToParts(d);
  const y = parts.find(p => p.type === 'year')!.value;
  const m = parts.find(p => p.type === 'month')!.value;
  const day = parts.find(p => p.type === 'day')!.value;
  // 00:00:00 UTC+1 = 23:00:00 UTC la veille.
  return Date.UTC(Number(y), Number(m) - 1, Number(day)) - 3_600_000;
};

/** Différence en jours entre deux epoch ms (positif si b > a). */
export const diffDays = (a: number, b: number): number =>
  Math.floor((b - a) / 86_400_000);

/** Vérifie si une échéance est dans le passé. */
export const isOverdue = (echeanceAt: number, now: number): boolean =>
  echeanceAt < now;

/** Vérifie si une échéance est dans les N prochains jours. */
export const isDueWithin = (echeanceAt: number, now: number, days: number): boolean => {
  if (echeanceAt < now) return true;
  return diffDays(now, echeanceAt) <= days;
};
